import { ColumnDef } from '@tanstack/react-table'

import { Company } from '@/interfaces/company'
import { companyTypeOptions } from '../filters/constants/statusOptions'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Dispatch, SetStateAction } from 'react'

export const getColumns = (
  setShowEditCompany: Dispatch<SetStateAction<boolean>>,
  setCompanyToEdit: Dispatch<SetStateAction<Company | undefined>>,
  setShowDeleteCompany: Dispatch<SetStateAction<boolean>>,
  setCompanyToDelete: Dispatch<SetStateAction<number | undefined>>
) => {
  const columns: ColumnDef<Company>[] = [
    {
      accessorKey: 'name',
      header: 'Nombre',
      cell: ({ row }) => {
        const name = row.original?.name || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: false, // Important column, don't allow hiding
    },
    {
      accessorKey: 'type',
      header: 'Tipo',
      cell: ({ row }) => {
        const type =
          companyTypeOptions?.find(
            (status) => status?.value === row.original?.type
          )?.label || ''
        return <span>{`${type}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'observations',
      header: 'Observaciones',
      cell: ({ row }) => {
        const observations = row.original?.observations || ''
        return <span>{`${observations}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'actions',
      header: 'Acciones',
      cell: ({ row }) => {
        const { id, name, type, observations } = row.original
        return (
          <div className={'flex justify-start'}>
            <div
              className={`p-2`}
              onClick={() => {
                // DEBUG: Edit button wrapper click functionality not implemented
              }}
              role={'button'}
            >
              <PencilSquareIcon
                className={`h-5 w-5 text-blue-700`}
                onClick={() => {
                  setShowEditCompany(true)
                  setCompanyToEdit({ id, name, type, observations })
                }}
              />
            </div>

            <div
              className={`p-2`}
              onClick={() => {
                // DEBUG: Delete button wrapper click functionality not implemented
              }}
              role={'button'}
            >
              <TrashIcon
                className={`h-5 w-5 text-red-700`}
                onClick={() => {
                  setShowDeleteCompany(true)
                  setCompanyToDelete(id)
                }}
              />
            </div>
          </div>
        )
      },
    },
  ]

  return columns
}
